import React from 'react';

/* Level-1 category tabs: ul.nav.nav-tab.fancy-subtabs under .casino_tabs_ul.
   Because this is NOT inside .newtab_collect and uses `nav-tab` (not `nav-tabs`),
   it gets the plain .fancy-subtabs styling (dark #343435 bar, white 12px,
   #6D081D active) with no specificity hijack and no Bootstrap .nav-tabs interference. */
export default function CategoryTabs({ categories, active, onChange, children }) {
  return (
    <div className="casino_tabs_ul tab-container">
      <ul role="tablist" className="nav nav-tab fancy-subtabs" aria-label="Tabs">
        {categories.map((cat, i) => {
          const on = i === active;
          return (
            <li className={on ? 'active nav-item' : 'nav-item'} key={cat.key}>
              <a
                href="javascript:void(0);"
                role="tab"
                aria-selected={on}
                className={on ? 'nav-link active' : 'nav-link'}
                onClick={(e) => { e.preventDefault(); onChange(i); }}
              >
                <span />
                <span>{cat.label}</span>
              </a>
            </li>
          );
        })}
      </ul>
      {/* tab-content nested INSIDE .casino_tabs_ul so the descendant CSS
          (.casino_tabs_ul .tab-content .csn_div .csn_thumb img{height:120px}) matches */}
      <div className="tab-content">
        <div role="tabpanel" className="tab-pane active">{children}</div>
      </div>
    </div>
  );
}
